import { ReturnRateTable } from '../return-rate-table'
import { ReverCard, ReverLoading } from '@itsrever/design-system'
import { ReturnRateGraph } from '../return-rate-graph'
import { useTranslation } from 'react-i18next'
import { useProductsReturnRate } from '@/application/queries'

interface ReturnRateProps {
  fromDate: string
  toDate: string
}

const ReturnRate: React.FC<ReturnRateProps> = ({ fromDate, toDate }) => {
  const { t } = useTranslation()

  const { productsReturnRate, totalEntries, loading } = useProductsReturnRate(
    fromDate,
    toDate
  )

  return (
    <div className="w-[1000px] p-4">
      <ReverCard className="pb-6 pl-4 pt-4" fullWidth>
        {loading ? (
          <ReverLoading />
        ) : (
          <ReturnRateGraph
            title={t('return_rate_table.top_products_returned')}
            itemsPurchased={productsReturnRate
              .slice(0, 10)
              .map((p) => p.totalPurchases)}
            itemsReturned={productsReturnRate
              .slice(0, 10)
              .map((p) => p.totalReturns)}
            returnRates={productsReturnRate
              .slice(0, 10)
              .map((p) => p.returnRate)}
            names={productsReturnRate.slice(0, 10).map((p) => p.name)}
          />
        )}
      </ReverCard>
      <ReturnRateTable
        entries={productsReturnRate}
        totalEntries={totalEntries}
        loading={loading}
      />
    </div>
  )
}

export default ReturnRate
